import CashOutSettingsForm from './CashOutSettingsForm.jsx';
import { connect } from 'react-redux';

import { Map } from 'immutable';
import { request as getCashOutSettings } from '../../../modules/system-settings/actions/get-cashout-settings';
import { request as postCashOutSettings } from '../../../modules/system-settings/actions/put-cashout-settings';

import decorate from '../../../utils/decorate';

import { flat, expandExtended } from './../../../utils/flat';
import { prepareDecimalFields } from './../../../utils/format';

const FULL_TEXT_FIELDS = [
    'globalMarketSettings.baseCashout',
    'globalMarketSettings.cashoutOverround',
    'globalMarketSettings.offerEasing',
    'algorithmInputSettings.power',
    'algorithmInputSettings.minimum',
];

function mapStateToProps(state) {
    const data = state.systemSettings.getIn(['cashOutSettings', 'data']);
    return {
        data: data ? prepareDecimalFields(flat(data.toJS()), FULL_TEXT_FIELDS, '/') : false,
        status: state.systemSettings.getIn(['cashOutSettings', 'state']) || 'IN_PROGRESS',
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCashOutSettingsGetRequest: () => dispatch(getCashOutSettings()),
        onCashOutSettingsPutRequest: (data) => {
            data = expandExtended(prepareDecimalFields(data, FULL_TEXT_FIELDS, '*', true));
            dispatch(postCashOutSettings({ data }));
        },
    };
}

export default decorate(connect(mapStateToProps, mapDispatchToProps), CashOutSettingsForm);
